import classNames from 'classnames';
import { useEffect, useRef } from 'react';

// import { KEYCODES, useKeyboardKeys } from '../../hooks/useKeyboardKeys';
import { usePopupsContext } from '../../contexts/PopupsContext';

export interface PopupsContainerProps {
    namespace?: string | null;
    className?: string | null;
    activeClassName?: string | null;
}

const PopupsContainer = ({
    namespace = null,
    className = null,
    activeClassName = null,
}: PopupsContainerProps) => {
    const { popups = null, setContainer } = usePopupsContext();

    const containerRef = useRef(null);

    const finalPopups =
        namespace !== null
            ? (popups || []).filter(
                  ({ namespace: popupNamespace, outsideContainer = false }) =>
                      popupNamespace === namespace && !outsideContainer,
              )
            : popups;

    useEffect(() => {
        setContainer(containerRef.current, namespace);
    }, [setContainer, namespace]);

    return (
        <div className={className}>
            <div
                className={classNames([
                    {
                        [activeClassName]: finalPopups !== null && finalPopups.length > 0,
                    },
                ])}
                ref={containerRef}
            />
        </div>
    );
};

export default PopupsContainer;
